// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"3c43c6ab","904":"3972db05"}[chunkId] + ".chunk.js";
};